var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import styled, { css } from 'styled-components';
import { ColorContextProvider } from '../../../src/providers/ColorContext';
import { Spacing } from '../../../components/Spacing';
import { spacings } from '../../../components/themes/spacings';
const borderRadiuses = {
    xxs: spacings['spacing-xxs'],
    xs: spacings['spacing-xs'],
    s: spacings['spacing-s'],
    m: spacings['spacing-m'],
    l: spacings['spacing-l'],
    xl: spacings['spacing-xl'],
    xxl: spacings['spacing-xxl'],
};
const StyledBox = styled(Spacing) `
  ${({ borderColor, backgroundColor, borderRadius = [0], theme: { colors }, }) => {
    return css `
      overflow: hidden;
      border-radius: ${borderRadius
        .map(key => (key ? borderRadiuses[key] : 0))
        .join(' ')};
      background-color: ${backgroundColor
        ? colors[backgroundColor] || backgroundColor
        : 'transparent'};
      border: 2px solid
        ${borderColor ? colors[borderColor] || borderColor : 'transparent'};
    `;
}}
`;
export function Box(_a) {
    var { children, backgroundColor = 'transparent', borderColor = 'transparent', borderRadius = [0] } = _a, rest = __rest(_a, ["children", "backgroundColor", "borderColor", "borderRadius"]);
    return (React.createElement(ColorContextProvider, { backgroundColor: backgroundColor },
        React.createElement(StyledBox, Object.assign({ backgroundColor: backgroundColor, borderColor: borderColor, borderRadius: borderRadius }, rest), children)));
}
